<p-stepper
  [value]="activeStep()"
  (valueChange)="onStepChange($event)"
  [linear]="false"
  class="shadow-dialog-stepper"
>
  <p-step-list class="shadow-dialog-stepper-desktop">
    <p-step [value]="1">{{ 'selectOrganisationType' | translate }}</p-step>
    <p-step [value]="2" [disabled]="isStepHeaderDisabled(2)">{{ 'selectOrganisation' | translate }}</p-step>
    <p-step [value]="3" [disabled]="isStepHeaderDisabled(3)">{{ 'selectRole' | translate }}</p-step>
  </p-step-list>

  <div
    class="shadow-dialog-stepper-mobile mb-2 sm:hidden"
    role="status"
    aria-live="polite"
    [attr.aria-label]="mobileStepProgressLabel()"
    data-testid="shadow-dialog-mobile-step"
  >
    <p class="mb-1.5 text-sm text-muted-color">{{ mobileStepProgressLabel() }}</p>
    <div class="h-1 w-full overflow-hidden rounded-full bg-surface-100">
      <div class="h-full bg-primary transition-all duration-200" [style.width.%]="mobileStepProgressPercent()"></div>
    </div>
  </div>

  @if (selectionPathItems().length > 0) {
    <div
      class="shadow-dialog-selection-path flex flex-wrap items-center gap-x-1.5 gap-y-1 overflow-visible rounded-border bg-surface-100 px-3 py-2 text-base"
      role="status"
      aria-live="polite"
      [attr.aria-label]="selectionSummaryAriaLabel()"
      data-testid="shadow-selection-summary"
    >
      <i class="pi pi-check-circle shrink-0 text-primary" aria-hidden="true"></i>
      @for (item of selectionPathItems(); track item.step; let last = $last) {
        <span class="max-w-[45vw] truncate font-medium text-surface-900 sm:max-w-none" [title]="item.label">
          {{ item.label }}
        </span>
        @if (!last) {
          <span class="shrink-0 font-medium text-muted-color" aria-hidden="true">&gt;</span>
        }
      }
    </div>
  }

  <p-step-panels>
    <p-step-panel [value]="1">
      <ng-template #content>
        <p-listbox
          id="shadowOrgTypeListbox"
          [options]="orgTypes()"
          optionValue="value"
          [ngModel]="selectedOrgType()"
          (ngModelChange)="onOrgTypeChange($event)"
          [disabled]="loadingOrgTypes()"
          [scrollHeight]="listboxScrollHeight"
          class="shadow-dialog-listbox w-full"
          [ariaLabel]="'selectOrganisationType' | translate"
        >
          <ng-template #item let-orgType>
            {{ orgTypeTranslationKey(orgType.value ?? '') | translate }}
          </ng-template>
        </p-listbox>
      </ng-template>
    </p-step-panel>

    <p-step-panel [value]="2">
      <ng-template #content>
        <p-listbox
          id="shadowOrganisationListbox"
          [options]="organisations()"
          optionValue="id"
          dataKey="id"
          [ngModel]="selectedOrganisationId()"
          (ngModelChange)="onOrganisationChange($event)"
          [disabled]="loadingOrganisations()"
          [filter]="true"
          filterBy="name,friendly_name"
          [filterPlaceHolder]="'search' | translate"
          [scrollHeight]="listboxScrollHeight"
          [emptyMessage]="'noResultsFound' | translate"
          class="shadow-dialog-listbox w-full"
          [ariaLabel]="'organisation' | translate"
        >
          <ng-template #item let-organisation>
            {{ organisationFriendlyName(organisation) }}
          </ng-template>
        </p-listbox>
      </ng-template>
    </p-step-panel>

    <p-step-panel [value]="3">
      <ng-template #content>
        <p-listbox
          id="shadowRoleListbox"
          [options]="roles()"
          optionValue="roleId"
          dataKey="roleId"
          [ngModel]="selectedRoleId()"
          (ngModelChange)="onRoleChange($event)"
          [disabled]="loadingRoles()"
          [filter]="true"
          filterBy="roleName"
          [filterPlaceHolder]="'search' | translate"
          [scrollHeight]="listboxScrollHeight"
          [emptyMessage]="'noResultsFound' | translate"
          class="shadow-dialog-listbox w-full"
          [ariaLabel]="'roleName' | translate"
        >
          <ng-template #item let-role>
            {{ getRoleLabel(role.roleName) }}
          </ng-template>
        </p-listbox>
      </ng-template>
    </p-step-panel>
  </p-step-panels>
</p-stepper>

@if (apiError()) {
  <p class="text-red-500 mt-3 mb-0" role="alert">{{ apiError() }}</p>
}

<div class="shadow-dialog-actions">
  <p-button
    type="button"
    class="shadow-dialog-cancel"
    [outlined]="true"
    [label]="'cancel' | translate"
    (onClick)="onCancel()"
    [disabled]="submitting()"
    data-testid="shadow-dialog-cancel"
  />
  <div class="shadow-dialog-nav-actions">
    @if (activeStep() > 1) {
      <p-button
        type="button"
        [outlined]="true"
        [label]="'back' | translate"
        icon="pi pi-arrow-left"
        iconPos="left"
        (onClick)="onBack()"
        [disabled]="submitting()"
        data-testid="shadow-dialog-back"
      />
    }
    <p-button
      type="button"
      [label]="proceedButtonLabelKey() | translate"
      [icon]="proceedButtonIcon()"
      iconPos="right"
      (onClick)="onProceed()"
      [disabled]="
        submitting() ||
        (activeStep() === 1 && (!canProceedStep1() || loadingOrgTypes())) ||
        (activeStep() === 2 && (!canProceedStep2() || loadingOrganisations())) ||
        (activeStep() === 3 && (!canProceedStep3() || loadingRoles()))
      "
      [loading]="submitting() || loadingOrganisations() || loadingOrgTypes() || loadingRoles()"
      data-testid="shadow-dialog-proceed"
    />
  </div>
</div>
